class BuildError extends Error {
  private errCode: string;

  constructor() {
    super("빌드 중 에러가 발생했습니다.");
    this.errCode = "0001";
  }
}

export default BuildError;
